import { useCallback, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { DropDownList, FilterDropdown } from "@repo/ui";

import { GridFiltersController } from "../api/gridFiltersController";
import { ISegment } from "../helpers/segmentFilterHook";

interface Props {
	value: number[];
	changeHandler: (value: number[], id: string) => void;
	label?: string;
	filters?: ISegment;
	id?: string;
}

export function RepsDropdown(props: Props) {
	const { filters = {}, id = "reps" } = props;
	const repFilters = useMemo(
		() => ({
			brands: filters.brandIds,
			channels: filters.channelIds,
			marketers: filters.marketerIds,
			states: filters.stateIds,
			branches: filters.branchIds,
			showInactiveOffices: filters.showInactiveOffices,
		}),
		[filters],
	);

	const repsQuery = useQuery({
		queryKey: ["RepsDropdown", repFilters],
		queryFn: () => GridFiltersController.getReps(repFilters),
	});

	const changeHandler = useCallback((v: number[]) => props.changeHandler(v, id), [props.changeHandler, id]);

	return (
		<FilterDropdown
			{...props}
			id={id}
			allOption
			values={repsQuery.data ?? []}
			loaded={!repsQuery.isLoading}
			changeHandler={changeHandler}
			objectName="Representatives"
			fullLength
			isMulti
		/>
	);
}
